import { defineComponent as _defineComponent } from 'vue'
import { chunk } from 'lodash'
import { computed } from 'vue'
import { useJobFilterStore } from '@/components/field-view-next/JobsFilterStore'
import { useRoute } from 'vue-router/composables'


export default /*#__PURE__*/_defineComponent({
  __name: 'Tags',
  props: {
    value: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { value: string[] }



const visibleTagCount = 8
const tagsPerRow = 4

const store = useJobFilterStore()
const route = useRoute()

const isFilteredJobsPage = computed(() => {
  return route.path.includes('/filtered-jobs')
})

const visibleTags = computed(() => {
  return props.value?.slice(0, visibleTagCount)
})

const overflowTags = computed(() => {
  return props.value.filter((tag) => !visibleTags.value.includes(tag))
})

const overflowTagMenuItem = computed(() => {
  return overflowTags.value.map((tag) => {
    return {
      text: tag,
      onClick: () => (isFilteredJobsPage.value ? null : setSearchValue(tag)),
    }
  })
})

const chunkedTags = computed(() => {
  return chunk(visibleTags.value, tagsPerRow)
})

const showViewMoreTags = (index) => {
  return (
    props.value.length > visibleTagCount &&
    chunkedTags.value.length - 1 === index
  )
}

const setSearchValue = (search: string) => {
  if (isFilteredJobsPage.value) return
  const formattedSearch = `tag:"${search}"`
  store.updateSearch(formattedSearch)
}

return { __sfc: true,props, visibleTagCount, tagsPerRow, store, route, isFilteredJobsPage, visibleTags, overflowTags, overflowTagMenuItem, chunkedTags, showViewMoreTags, setSearchValue, chunk }
}

})